import { isQuoteExpired, QUOTE_CHECKOUT_MARGIN_MS } from '@/lib/delivery/dispatchable'
import type { DeliveryMode, DropoffAddress, HeldQuote } from '../types'

/**
 * ¿Hay que re-cotizar en silencio al abrir el checkout? (spec 2026-09-03 §4.10)
 * Sí cuando el cliente viene en domicilio con dirección pero la cotización ya no
 * sirve para pagar: vencida, dentro del margen del checkout, o ausente (se limpia
 * al confirmar un pedido). Un solo reloj: isQuoteExpired con
 * QUOTE_CHECKOUT_MARGIN_MS, el mismo que usan la barra y el salto del paso.
 */
export function shouldRequoteOnOpen(s: {
  deliveryMode: DeliveryMode
  dropoff: DropoffAddress | null
  heldQuote: HeldQuote | null
  now: number
}): boolean {
  if (s.deliveryMode !== 'delivery' || !s.dropoff) return false
  if (!s.heldQuote) return true
  return isQuoteExpired(s.heldQuote, s.now, QUOTE_CHECKOUT_MARGIN_MS)
}
